(function () {
  function adjustLoyaltyButton() {
    if (window.innerWidth > 768) return;

    const button = document.querySelector('#appstle-loyalty-button');
    if (!button) return;

    const points = button.querySelector('.loyalty_widget_available_points');
    const hasPoints = points && points.textContent.trim() !== '';

    if (hasPoints) {
      button.style.setProperty('margin-right', '-38px', 'important');
    } else {
      button.style.setProperty('margin-right', '-9px', 'important');
    }
  }

  document.addEventListener('DOMContentLoaded', adjustLoyaltyButton);
  window.addEventListener('resize', adjustLoyaltyButton);

  const observer = new MutationObserver(adjustLoyaltyButton);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();